import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getVoteHeads } from "../../redux/actions/voteHeadActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (voteHeadId: string) => void;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const VoteHeadSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Vote Head",
  allLabel = "All Vote Heads",
  minWidth = 140,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: voteHeads,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.voteHead);
  const attempted = useRef(false);

  useEffect(() => {
    if (!voteHeads.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getVoteHeads());
    }
  }, [dispatch, voteHeads.length, loading, error]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={voteHeads.map((v) => ({ value: v.id, label: v.name }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};
export default VoteHeadSelectFilter;
